var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _circle, _path7, _path8, _path9, _path0, _path1, _rect3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _rect5, _circle2, _rect6, _rect7, _text, _path18, _path19, _circle3, _circle4, _circle5, _path20, _rect8, _polygon, _polygon2, _circle6, _circle7, _polygon3, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileappdevelopmenttab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d8c4df;}.cls-14,.cls-2{fill:#2f2143;}.cls-3{fill:#9a499c;}.cls-4{fill:#e3dfe5;}.cls-5{fill:#ffc636;}.cls-6{fill:#ffc436;}.cls-7{fill:#321f46;}.cls-8{fill:#faab77;}.cls-9{fill:#6b7bbc;}.cls-10{fill:#2f2243;}.cls-11{fill:#1e3966;}.cls-12{fill:#fff;}.cls-13,.cls-15,.cls-16,.cls-17{fill:none;stroke-miterlimit:10;}.cls-13{stroke:#fff;stroke-width:0.48px;}.cls-14{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-15{stroke:#9a499c;stroke-width:1px;}.cls-16,.cls-17{stroke:#2f2143;}.cls-16{stroke-width:3.24px;}.cls-17{stroke-width:1.06px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mobile app development tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.4,246.32H134.5a10.56,10.56,0,0,1-10.57-10.56V77.22A10.56,10.56,0,0,1,134.5,66.66h84.9A10.56,10.56,0,0,1,230,77.22V235.76a10.56,10.56,0,0,1-10.57,10.56",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.41,234.73H139.49a9.37,9.37,0,0,1-9.37-9.37V84a9.38,9.38,0,0,1,9.37-9.37h74.92A9.38,9.38,0,0,1,223.78,84V225.36a9.37,9.37,0,0,1-9.37,9.37",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.12,97.25H169a8,8,0,0,1,8,8v26a8,8,0,0,1-8,8H130.12a0,0,0,0,1,0,0V97.25A0,0,0,0,1,130.12,97.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M198.05,188.88h9.43a10,10,0,0,1,10,10v0a10,10,0,0,1-10,10h-2.13a10.16,10.16,0,0,1-10.16-10.16v-7A2.86,2.86,0,0,1,198.05,188.88Z",
    transform: "translate(412.7 397.8) rotate(180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187.65,81.53h-21a1.69,1.69,0,0,1,0-3.38h21a1.69,1.69,0,0,1,0,3.38",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184,226.48a7.07,7.07,0,1,1-7.07-7.07,7.08,7.08,0,0,1,7.07,7.07",
    transform: "translate(0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 105.97,
    y: 192.09,
    width: 35.57,
    height: 13.62,
    rx: 6.43,
    transform: "translate(247.51 397.8) rotate(-180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 112.78,
    cy: 198.9,
    r: 6.81
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M42.56,261.46s-4.23-.21-5.48-2.09-3.36-20.9-.46-30.84c0,0,5.29-14.76,3.78-19.16l-1.54-35L64.68,172s-4.82,32.53-7.29,36.86C57.39,208.88,44.7,258.57,42.56,261.46Z",
    transform: "translate(0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.51,260.34s-12.73-20.74-14-32.64c0,0-.72-9.16-.14-14.42l-7.12-40.83H74s2.42,17.36.62,31.23-2.16,17.55-2.1,19.75,3.19,28.23,5.6,36.55A5,5,0,0,1,72.51,260.34Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M69.15,178.24a22.35,22.35,0,0,1-2.22,4.36c-.9,1-21.91,2.91-33-6.2,0,0,7.59-46.39,17.62-62.51,0,0,2.41-3.62,12-3.48,0,0,0-1,2.27-1.32L71,122s5.09-9.19,4.76-9.78,1.62,1.42,1.69,2.8c0,0,4.35,2.11,5,2.66s1.68-.12,5.53,11.19S95.44,144,95.44,144l-1.56,11.6L83.69,147.4l-3.2-4.13L77.75,180,70,182,69.29,178",
    transform: "translate(0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71,122.41,65.8,108.76s3.32-5.45,3.48-8.8l8.41,4.3a75.28,75.28,0,0,0-1.93,7.59S73.79,118.73,71,122.41Z",
    transform: "translate(0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.63,93.78s-1.24,3.2-.47,4.84,2,4.52,7.69,6.16c0,0,2.53,1.52,3.79-.77,0,0,3-4.12,3.67-7.15,0,0,.88-9.52-1.34-9.87S69.1,91.65,68.63,92.41A1.22,1.22,0,0,0,68.63,93.78Z",
    transform: "translate(0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 93.95,
    y: 143.05,
    width: 60.85,
    height: 22.9,
    rx: 3.78
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M83.42,96.44s-1-.09-.57-6A5.5,5.5,0,0,0,81.27,87S76.72,95.21,70.56,96a25,25,0,0,0,5.76-4.3,8.63,8.63,0,0,1-7.58,1.39,11.52,11.52,0,0,0-.47,5.08l-.37,1.38s-.63-2.37-1.88-2.35a2.35,2.35,0,0,1-2.7-1s-1.89-1.94-1.63-6.09A13.91,13.91,0,0,1,64,83.47a4.48,4.48,0,0,1-1.72,0s-1.41-.39-2.28-4.37c0,0-.79-2.76,2.17-6.1,0,0,1.61-2.22,5.8.78,0,0-.64-1.76-4.49-2.14,0,0,7.44-.19,8.18,5.86,0,0,5.88-3.91,12.48,8.72C84.14,86.19,88.09,89.67,83.42,96.44Z",
    transform: "translate(0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M69.19,159.57s11.55,3.65,16.54,4.29c0,0,6.21,1.67,8.14,2.47s8.65-.22,8.34-5.18c0,0-.54-.55-3.33-.39,0,0-3.29-.17-3.63-.58,0,0,2.77-.15,2.84-.43,0,0,1-.32.5-1,0,0-.68-.39-5.51.12l-6.66.19-13.91-8.38Z",
    transform: "translate(0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.49,269.37s-.6-3.83.55-5.2c0,0,1.55-1.74-.14-4.47,0,0,3.56,1.29,6.16-.4,0,0,4.68,5.46,5.53,5.81,0,0,7.57,1,7.32,4.26Z",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M36,269.73s-.61-3.84.54-5.21c0,0,1.78-3.8.1-6.53,0,0,3.89,4,6.5,2.33,0,0,4.11,4.8,5,5.15,0,0,7.57,1,7.32,4.26Z",
    transform: "translate(0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.21,150.08q5.73-.15,11.44-.2l11.43-.07,11.44.06q5.72.06,11.43.21-5.72.15-11.43.21l-11.44.06-11.43-.06Q102.94,150.23,97.21,150.08Z",
    transform: "translate(0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.21,154.27c3.45-.1,6.89-.17,10.34-.21l10.33-.06,10.34.06c3.44,0,6.89.11,10.33.21-3.44.1-6.89.17-10.33.21l-10.34.06-10.33-.07C104.1,154.44,100.66,154.37,97.21,154.27Z",
    transform: "translate(0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.21,157.64q4.77-.15,9.52-.2l9.51-.06,9.52.06q4.76,0,9.51.2-4.76.15-9.51.21l-9.52.06-9.51-.06Q102,157.79,97.21,157.64Z",
    transform: "translate(0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.15,161c2.1-.11,4.19-.17,6.29-.21l6.29-.06,6.29.06c2.1,0,4.19.09,6.29.21-2.1.11-4.19.16-6.29.2l-6.29.06-6.29-.06C106.34,161.18,104.25,161.13,102.15,161Z",
    transform: "translate(0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 141.77,
    y: 154.74,
    width: 8.24,
    height: 7.02
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 97.97,
    x2: 217.51,
    y2: 97.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 106.05,
    x2: 217.51,
    y2: 106.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 114.12,
    x2: 217.51,
    y2: 114.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 122.19,
    x2: 217.51,
    y2: 122.19
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 130.26,
    x2: 217.51,
    y2: 130.26
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 182.07,
    y1: 138.33,
    x2: 217.51,
    y2: 138.33
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.97,
    y: 132.91,
    width: 32.21,
    height: 12.33,
    rx: 5.83
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 227.01,
    cy: 139.08,
    r: 6.17
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.09,
    y: 170.52,
    width: 87.53,
    height: 2.15,
    rx: 1.07
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 133.09,
    y: 179.79,
    width: 87.53,
    height: 2.15,
    rx: 1.07
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-14",
    transform: "translate(348.23 137.91)"
  }, "MOBILE ", /*#__PURE__*/React.createElement("tspan", {
    x: -90.3,
    y: 37
  }, "APP DEVELOPMENT"))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M588.21,32.27A15.49,15.49,0,0,0,586,37.6l-3,.28v5.76l3,.28a15.49,15.49,0,0,0,2.2,5.33l-1.9,2.3,4.08,4.08,2.29-1.91a15.11,15.11,0,0,0,5.33,2.2l.28,3h5.77l.28-3a15.19,15.19,0,0,0,5.33-2.2L612,55.63,616,51.55l-1.9-2.3a15.49,15.49,0,0,0,2.2-5.33l3-.28V37.88l-3-.28a15.49,15.49,0,0,0-2.2-5.33L616,30,612,25.9l-2.29,1.9a15.57,15.57,0,0,0-5.33-2.2l-.28-3h-5.77l-.28,3a15.49,15.49,0,0,0-5.33,2.2l-2.29-1.9L586.31,30Zm18.48,3a7.8,7.8,0,1,1-11,0,7.8,7.8,0,0,1,11,0",
    transform: "translate(0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.51,236.52a9,9,0,0,0-1.31,3.16l-1.77.17v3.43l1.77.17a9.12,9.12,0,0,0,1.31,3.17L382.38,248l2.42,2.43,1.37-1.13a9.21,9.21,0,0,0,3.17,1.3l.16,1.77h3.43l.17-1.77a9.21,9.21,0,0,0,3.17-1.3l1.36,1.13,2.43-2.43-1.13-1.36a9.31,9.31,0,0,0,1.31-3.17l1.77-.17v-3.43l-1.77-.17a9.18,9.18,0,0,0-1.31-3.16l1.13-1.37-2.43-2.42-1.36,1.13a9,9,0,0,0-3.17-1.31l-.17-1.77H389.5l-.16,1.77a9,9,0,0,0-3.17,1.31l-1.37-1.13-2.42,2.42Zm11,1.76a4.64,4.64,0,1,1-6.56,0,4.65,4.65,0,0,1,6.56,0",
    transform: "translate(0)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 440.36,
    cy: 33.07,
    r: 9.49
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 298.05,
    cy: 234.78,
    r: 9.49
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 294.93,
    cy: 67.86,
    r: 6.88
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.13,95.8a14.43,14.43,0,0,1,27-10.26",
    transform: "translate(0)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 672.8,
    y: 216.36,
    width: 44.52,
    height: 41.49
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "675.47 257.85 688.35 236.69 700.12 257.85 675.47 257.85"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "692.67 257.85 705.54 225.28 717.32 257.85 692.67 257.85"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 681.77,
    cy: 222.48,
    r: 3.45
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 700.12,
    cy: 115.71,
    r: 17.38
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "709.59 115.71 694.09 106.76 694.09 124.66 709.59 115.71"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 548.72,
    cy: 228.92,
    r: 10.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileappdevelopmenttab);
export default __webpack_public_path__ + "static/media/Mobile app development tab.0499dbc9eef80655c804708f6bd482e3.svg";
export { ForwardRef as ReactComponent };